<template>
  <VModal ref="modal" @modal:hidden="$emit('hide')" disable-backdrop-click>
    <BaseVeeForm
      :action="handleSubmit"
      v-slot="{ isPending, isRejected, invalid }"
      class="mx-auto max-w-lg"
    >
      <BaseCard @click.stop>
        <BaseCardHeader> Delete service </BaseCardHeader>
        <BaseCardBody>
          <p class="text-gray-600 mb-4">
            Are you sure you want to delete this service? Once a service is deleted, you want be
            able to recover it.
          </p>
        </BaseCardBody>
        <BaseCardFooter gray>
          <div class="flex space-x-2">
            <BaseButton primary :disabled="isPending || isRejected || invalid">
              Delete Service
            </BaseButton>
            <BaseButton type="button" ghost :disabled="isPending" @click="$refs.modal.close()">
              Cancel
            </BaseButton>
          </div>
        </BaseCardFooter>
      </BaseCard>
    </BaseVeeForm>
  </VModal>
</template>

<script>
export default {
  props: {
    thirdPartyServiceId: {
      type: String,
      required: true,
    },
    onDelete: {
      type: Function,
      required: true,
    },
  },
  methods: {
    async handleSubmit() {
      try {
        await this.onDelete();

        this.$refs.modal.close();

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
